import DomainCommon from './common';

const SurveyCountService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/mission`,
                resolve, reject
            });
        });
    },
    findById: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}`,
                resolve, reject
            });
        });
    },
};

export default SurveyCountService;



// WEBPACK FOOTER //
// ./src/service/surveyCount.js